module.exports = __webpack_public_path__ + "static/img/Home_main.956e199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/Home_main.jpg
// module id = asAb
// module chunks = 7